import styled from 'styled-components'

import { system, propTypes } from './lib/system'

const Cell = styled.div`
  margin-left: auto;
  margin-right: auto;

  ${system}
`

Cell.propTypes = {
  ...propTypes,
}

Cell.defaultProps = {
  maxWidth: '46.875rem',
}

export default Cell
